import { gql } from "@apollo/client";

export const UpdateSquarePhotosSection = gql`
mutation UpdateSquarePhotosSection($content: contentUpdateSquarePhotosSection!) {
  updateSquarePhotosSection(content: $content) {
    status
  }
}
`;
